/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowwhendate3Inputs */

const en_aiflowwhendate3 = /** @type {(inputs: Aiflowwhendate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_aiflowwhendate3 = /** @type {(inputs: Aiflowwhendate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Aiflowwhendate3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowwhendate3 = /** @type {((inputs?: Aiflowwhendate3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowwhendate3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowwhendate3(inputs)
	return de_aiflowwhendate3(inputs)
});
export { aiflowwhendate3 as "aiFlowWhenDate" }